import { RouterProvider, useSearchParams } from "react-router-dom";
import { router } from "./Router/router";
import useNotification from "./hooks/useNotification";
import { useSelector } from "react-redux";
import { useEffect } from "react";

export default function App() {
  // const { agencyId } = useSelector((state) => state.auth);
  // const notification = useNotification(agencyId, "agency");

  // useEffect(() => {
  //   console.log(notification);
  //   alert("notification ");
  // }, [notification]);

  return <RouterProvider router={router} />;
}
